import { type FunctionalComponent, h } from '@stencil/core';

export const ConversationalSearchDynamicBannerAnimatedTag: FunctionalComponent<{
}> = (props) => {
    return (
      <section class="conversational-search-banner-dynamic-animated-tag">
        <qds-icon name="sparkles" size="large" library="default" />
      </section>
    );
};
